import React from "react";

const OptionHero = () => {
  return (
    <div>
      <div className="row container m-auto py-5 my-5">
        <div className="col-md-5">
          <div class="card" style={{ cursor: "pointer" }}>
            <img
              src="https://b.zmtcdn.com/webFrontend/e5b8785c257af2a7f354f1addaf37e4e1647364814.jpeg?output-format=webp&fit=around|402:360&crop=402:360;*,*"
              class="card-img-top"
              style={{ height: "130px", objectFit: "cover" }}
              alt="Order Online Image"
            />
            <div class="card-body">
              <h5 class="card-title">Order Online</h5>
              <p class="card-text">Stay home and order to your doorstep</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionHero;
